<template>
    <span class="o-t-tile t-tile">
        <img
            v-if="t(item, 'icon')"
            class="t-tile__img"                                        
            :src="t(item, 'icon')"
            :alt="`${$t('t_tile-icon')}`"
        >
        <svg-icon
            v-else
            original
            name="icons/marker"
            class="o-t-tile__icon"
        />
        <span
            class="t-tile__title"
            ref="t-tile__title"
            :class="{'t-tile__title--small-text': tTileHeight > 60 }"
        >
            {{ name }}
        </span>
        <AItemInfo
            :item="item"
        />
    </span>
</template>

<script>
import { 
    mapGetters,
    mapState 
} from 'vuex';

import AItemInfo from '../../atoms/a-item-info/a-item-info';

export default {
    name: 'OTTile',
    components: {
        AItemInfo
    },
    data: () => ({
        tTileHeight: null,
        name: ''
    }),
    props: {
        item: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        ...mapGetters([
            't'
        ]),
        ...mapState({
            mapLoading: state => state.mapLoading
        }),
    },
    updated() {
        this.name = this.t(this.item, 'name')
    },
    watch: {
        name () {
            this.changeTileHeight()
        },
        item() {
            this.tTileHeight = 0
            this.changeTileHeight()
        },
        mapLoading() {
            this.changeTileHeight()
        }
    },
    mounted() {
        this.name = this.t(this.item, 'name')
    },
    methods: {
        changeTileHeight() {
            this.$nextTick(() => this.tTileHeight = this.$refs['t-tile__title'].offsetHeight)
        }
    }
}
</script>

<style lang="scss">
@import "o-t-tile";
</style>